import React, { FunctionComponent, useEffect, useState } from 'react';
import { Line, XAxis, YAxis, Tooltip, Legend,  Label, Scatter, ComposedChart } from 'recharts';
import moment from 'moment';
import '../../stations/Station.scss';
import { CustomizedAxisTick } from '../chartsPopUpConstants';
import { ONEDAY, getMaxFromSelectedFields, getMinFromSelectedFields } from 'src/store/common';

type WindMaxChartProps = {
    all_dates: any[],
}

const CustomTooltip:FunctionComponent = (props:any) => {
  const {active, label,payload}=props;

  if (active && payload && payload.length) {
    return (
      <div id="custom-tooltip" className="custom-tooltip" style={{backgroundColor: 'white', border: 'none !important', display:'block',height:'5rem', width: '5.25rem'}}>
        <span className="month" style={{fontSize: '.75rem', paddingBottom: '0px', paddingTop:'0px', display:'block'}}>
        {moment(label).format("MMM DD, YYYY")}
        </span>
        <svg width="50" height="12" style={{display: 'block', marginTop: '5px'}}>
          <rect width="5" height="5" style={{fill:'red'}}/>
          <text
            fontSize=".75rem"
            height="8"
            x={10}
            y={10}
          >
          {`${payload[0].value}`}
        </text>
        </svg>
        <svg width="50" height="12" style={{display: 'block', marginTop: '5px'}}>
          <rect width="5" height="5" style={{fill:'grey'}}/>
          <text
            fontSize=".75rem"
            height="8"
            x={10}
            y={10}
          >
          {`${payload[1].value}`}
        </text>
        </svg>
        <svg width="50" height="12" style={{display: 'block',marginTop: '5px'}}>
          <rect width="5" height="5" style={{fill:'blue'}}/>
          <text
            fontSize=".75rem"
            height="8"
            x={10}
            y={10}
          >
          {`${payload[2].value}`}
        </text>
        </svg>
      </div>
    );
  }
  return null;
};
const RenderDot:FunctionComponent = (props:any) => {
  if(props.cy===null){
    return null
  }else{
    return (
      <circle cx={props.cx} cy={props.cy} r="2"fill={props.fill}/>
    )
  }
}
export const WindMaxChart: React.FC<WindMaxChartProps> = ({
  all_dates
}) => {
  const [xTicks, setXTicks] = useState<number[]>([]);
  useEffect(()=>{
    if(all_dates.length>1){
      let ticks:number[]=[];

      if(ticks.length<1){
        let i = moment(all_dates[0].date).format('MMM DD');
        ticks.push(all_dates[0].date)
        let j=0;
        while(i !== moment(all_dates.at(-1).date).format('MMM DD')){          
          j=j+1;
          ticks.push(all_dates[0].date + j*ONEDAY)
          i = moment(all_dates[0].date + j*ONEDAY).format('MMM DD')
        }
        setXTicks(ticks)
      }
  
    }
  },[all_dates, ]);   
  
  return(
    <>
    {all_dates.length>1 && (
        <ComposedChart
          width={375}
          height={190}
          data={all_dates}
          margin={{
            top: (10),
            right: 5,
            left: 5,
            bottom: 10,
          }}
        >
          <XAxis dataKey="date" interval={0} type="number" tick={<CustomizedAxisTick />} domain={[all_dates.at(-1).date, all_dates[0].date]} ticks={xTicks}/>          
          <YAxis yAxisId="left" 
            domain={[getMinFromSelectedFields(all_dates, ['maxGustObs', 'maxGustF', 'maxSpeedObs', 'maxSpeedF'],5), getMaxFromSelectedFields(all_dates, ['maxGustObs', 'maxGustF','maxSpeedObs', 'maxSpeedF'])]}
            style={{fontSize: '1rem',fontFamily: 'serif'}}
            axisLine={false}>
          <Label
            value="Speed"
            position="insideLeft"
            angle={-90}
            fontSize={'0.7rem'}
            style={{ textAnchor: 'middle'}}
          />
          </YAxis>
          <YAxis yAxisId="right" orientation="right" 
            domain={[getMinFromSelectedFields(all_dates, ['gustDir'],50), getMaxFromSelectedFields(all_dates, ['gustDir'])]}
            style={{fontSize: '1rem',fontFamily: 'serif'}} 
            axisLine={false}>
          <Label
            value="Direction"
            position="insideRight"
            angle={-90}
            fontSize={'0.7rem'}
            style={{ textAnchor: 'middle' }}
          />
          </YAxis>
          <Tooltip content={<CustomTooltip />} position={{ y: -5 }} />
          <Legend wrapperStyle={{fontSize:'11px', top:'160px'}}iconType="plainline" iconSize={20}/>
          <Scatter name="Wind Direction" dataKey="gustDir" fill="#be0000" yAxisId ="right" shape={<RenderDot/>}/>
          <Line name="Wind Speed" type="monotone" yAxisId ="left" dataKey="maxSpeedObs" stroke="#4C4E4E" dot={ false} strokeWidth={4}/>
          <Line name="Wind Speed Forecast" type="monotone" yAxisId = "left" dataKey="maxSpeedF" stroke="#4C4E4E" dot={false} strokeDasharray="5 5" strokeWidth={2}/>
          <Line name="Gust Speed" type="monotone" yAxisId ="left" dataKey="maxGustObs" stroke="blue" dot={ false} strokeWidth={4}/>
          <Line name="Gust Speed Forecast" type="monotone" yAxisId = "left" dataKey="maxGustF" stroke="blue" dot={false} strokeDasharray="5 5" strokeWidth={2}/>
        </ComposedChart>
    )
    }
    </>

  );
}